import { cn } from '../cn'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />
}

interface CardSkeletonProps {
  /** Number of body lines to render. Default: 3. */
  lines?: number
  className?: string
}

function CardSkeleton({ lines = 3, className }: CardSkeletonProps) {
  return (
    <div className={cn('bg-card rounded-xl border p-6', className)}>
      <Skeleton className="h-5 w-1/3 mb-4" />
      <div className="space-y-3">
        {Array.from({ length: lines }).map((_, i) => (
          <Skeleton key={i} className="h-4" style={{ width: `${85 - i * 15}%` }} />
        ))}
      </div>
    </div>
  )
}

interface TableSkeletonProps {
  /** Number of body rows to render. Default: 5. */
  rows?: number
  className?: string
}

function TableSkeleton({ rows = 5, className }: TableSkeletonProps) {
  return (
    <div className={cn('bg-card rounded-xl border', className)}>
      <div className="p-4 border-b flex gap-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-8 w-32" />
      </div>
      <div className="divide-y">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="p-4 flex items-center gap-4">
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-4 w-1/6" />
            <Skeleton className="h-4 w-1/5" />
            <Skeleton className="h-4 w-16" />
          </div>
        ))}
      </div>
    </div>
  )
}

function PageHeaderSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center justify-between mb-6', className)}>
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-10 w-32 rounded-lg" />
    </div>
  )
}

export { CardSkeleton, type CardSkeletonProps, PageHeaderSkeleton, Skeleton, TableSkeleton, type TableSkeletonProps }
